import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { FreebetsIcon } from '../../../../assets/img/betting';
import Formatter from '../../../../i18n/formatter';
import { getCurrency } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';

const Wrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
`;

type IconType = {
  $small: boolean;
};

const Icon = styled.img<IconType>`
  ${({ $small }) =>
    $small
      ? css`
          width: 0.9em;
          margin-left: 0.25em;
        `
      : css`
          width: 1.2em;
          margin-left: 0.125em;
        `}
`;

const Value = styled.div`
  color: ${theme.MissionFreebetsPotentialGain.color};
  font-weight: 500;
`;

type MissionFreebetsPotentialGainProps = {
  className?: string;
  amount: number;
  smallIcon?: boolean;
};

const MissionFreebetsPotentialGain = ({
  className = '',
  amount,
  smallIcon = false,
}: MissionFreebetsPotentialGainProps) => {
  const displayedValue = useMemo(
    () =>
      typeof amount === 'number' ? Formatter.formatBankroll(amount * 100, getCurrency(), !((amount ?? 0) % 1)) : null,
    [amount],
  );

  return amount && displayedValue ? (
    <Wrapper className={className}>
      <Value>{displayedValue}</Value>
      <Icon src={FreebetsIcon} $small={smallIcon} />
    </Wrapper>
  ) : null;
};

export default MissionFreebetsPotentialGain;
